<div class="container">
  <!--Navbar starts here-->
  <nav
    class="
      navbar
      fixed-top
      navbar-expand-md navbar-expand-lg navbar-expand-xl navbar-dark
    "
    style="z-index: 999"
  >
    <span>
      <a class="navbar-brand" >
        <img src="assets/images/UST QE360_White.png" alt="logo" class="ns-logo" />
      </a>
    </span>
    <button class="navbar-toggler" type="button" (click)="toggleNavbar()">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div 
      class="collapse navbar-collapse"
      id="collapsibleNavbar"
      [ngClass]="{ show: navbarOpen }"
    >
      <ul class="navbar-nav mr-auto ml-4">
        <li class="nav-item" *ngFor="let menuItem of main_menu_items">
          <button class="matMenu"  mat-button  routerLink="/{{menuItem.route}}">
            <i class="fa fa-{{menuItem.icon}} icon--cust" aria-hidden="true"></i>
            <span>{{menuItem.name}}</span>
          </button>
        </li>
      </ul>

      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link" >
            <div class="profile-header-container">
              <div class="profile-header-img">
                <img
                  [src]="profilePicture"
                  class="img-circle banner__logosz"
                  alt="Hi {{ username | titlecase }}"
                  title="Hi {{ username | titlecase }}"
                />
              </div>
            </div>
          </a>
        </li>
        <li class="nav-item profile">
          <button class="matMenu" mat-button [matMenuTriggerFor]="userProfile">{{ username | titlecase }}
            <i class="fa fa-chevron-down" aria-hidden="true"></i>
         </button>
         <mat-menu #userProfile>
          <button class="dropdown" routerLink="/manage-user" mat-menu-item class="white-color-font" *ngIf="userRole == AppSettings.USER_ROLES.ADMIN">
            Manage User
          </button>
           <button class="dropdown" (click)="logout()" mat-menu-item class="white-color-font">
             Logout
           </button>
         </mat-menu>

        </li>
      </ul>
    </div>

  </nav>
</div>
